import type { ResponseGetUser } from '../../app/ApiGen';
import { request } from '../../utils/request';

export type Response = ResponseGetUser;

export const getCurrentUser = async (id: string): Promise<Response> =>
  request<Response>(`/users/${id}`, { method: 'GET' });
